import { API } from "@/lib/api";

export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${API}${u.slice(4)}` : u);

export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const fmtDate = (d, opts = { weekday: "long", month: "long", day: "numeric", year: "numeric" }) =>
  new Date(`${d}T12:00:00`).toLocaleDateString("en-US", opts);

export const timeRange = (e) => [fmtTime(e.start_time), fmtTime(e.end_time)].filter(Boolean).join(" – ");

export function gcalLink(e) {
  const d = e.date.replace(/-/g, "");
  const t = (x) => (x ? `T${x.replace(":", "")}00` : "");
  const dates = e.start_time ? `${d}${t(e.start_time)}/${d}${t(e.end_time || e.start_time)}` : `${d}/${d}`;
  const p = new URLSearchParams({
    action: "TEMPLATE", text: e.title, dates, ctz: "America/New_York",
    details: e.description || "", location: [e.location_name, e.address].filter(Boolean).join(", "),
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

export const mapLink = (e) => `https://maps.google.com/?q=${encodeURIComponent(e.address || e.location_name)}`;

export const fmtPrice = (cents) => `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`;

export const canSignUp = (e) => !!e.price_cents && e.date >= todayStr();

export const todayStr = () => {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
};
